module.exports = "{{#each columns}} <div class=grid-header-column> <div class=grid-header-column-content-view></div> {{#unless @last}} <div class=grid-header-dragger></div> {{/unless}} </div> {{/each}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/gridheader.hbs
// module id = 708
// module chunks = 0